import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { KENDO_FORMFIELD, KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';

@Component({
  selector: 'unity-textbox-readonly-control',
  standalone: true,
  imports: [KENDO_FORMFIELD, KENDO_TEXTBOX, KENDO_LABEL, ReactiveFormsModule],
  templateUrl: './textbox-readonly-control.component.html',
  styleUrl: './textbox-readonly-control.component.scss',
})
export class TextboxReadonlyControlComponent {
  public readonly $value = input.required<string>({ alias: 'value' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
}
